import { HStack, VStack } from "../../../styled-system/jsx";
import moment from "moment";
import Card from "./Card";
import { css } from "../../../styled-system/css";
import Pill from "./Pill";
import { useTranslation } from "react-i18next";

const useFormatFromNow = () => {
  const { t } = useTranslation(["chat"]);
  return (date) => {
    const now = moment();
    date = moment(date);
    const diffInMinutes = now.diff(date, "minutes");
    if (diffInMinutes < 1) return t(($) => $.chat["now"]);
    if (diffInMinutes < 60) return t(($) => $.chat["{count}m"], { count: diffInMinutes });
    const diffInHours = now.diff(date, "hours");
    if (diffInHours < 24) return t(($) => $.chat["{count}h"], { count: diffInHours });
    const diffInDays = now.diff(date, "days");
    if (diffInDays < 7) return t(($) => $.chat["{count}d"], { count: diffInDays });
    const diffInWeeks = now.diff(date, "weeks");
    if (diffInWeeks < 4) return t(($) => $.chat["{count}w"], { count: diffInWeeks });
    const diffInMonths = now.diff(date, "months");
    if (diffInMonths < 12) return t(($) => $.chat["{count}mo"], { count: diffInMonths });
    const diffInYears = now.diff(date, "years");
    return t(($) => $.chat["{count}y"], { count: diffInYears });
  };
};

const SidebarItem = ({ children, label, createdOn, badge, active, onClick, wrap = false }) => {
  const formatFromNow = useFormatFromNow();
  return (
    <Card active={active} onClick={onClick} hoverable>
      <VStack alignItems="flex-start" spacing="4px" width="100%">
        <HStack justifyContent="space-between" width="100%" alignItems={"flex-start"}>
          {wrap ?
            <span
              className={css({
                whiteSpace: "normal",
                overflow: "hidden",
                fontSize: "14px",
                fontWeight: "bold",
                color: "black",
                textOverflow: "ellipsis",
              })}
            >
              {badge && <Pill variant={badge}>{badge}</Pill>}
              {label}
            </span>
          : <span
              className={css({
                whiteSpace: "nowrap",
                overflow: "hidden",
                fontSize: "14px",
                fontWeight: "bold",
                color: "black",
                textOverflow: "ellipsis",
              })}
            >
              {badge && <Pill variant={badge}>{badge}</Pill>}
              {label}
            </span>
          }
          {createdOn && <span className={css({ fontSize: "12px", color: "#6b7280" })}>{formatFromNow(createdOn)}</span>}
        </HStack>
        {children}
      </VStack>
    </Card>
  );
};

export default SidebarItem;
